import { defineMessages } from 'react-intl';

const trns = defineMessages({
  next: {
    id: 'Ar1W3e',
    defaultMessage: 'Далі'
  },
  specifyQuantityOfProduct: {
    id: 'wkWBlw',
    defaultMessage: 'Вкажіть кількість товару'
  },
  packageContains: {
    id: 'PXE3Vo',
    defaultMessage: 'Упаковка містить '
  },
  platesAndPills: {
    id: 'XfGIwQ',
    defaultMessage: '{plates} пластини по {pills} таблеток'
  }
});

export default trns;
